/**
 * 装饰器设计思路, 给simple-header和common-header增加新的样式和行为。
 */
import { $window } from '@umu/umu-dom';
import { IUserInfo } from '@umu/umu-types';
import { getShoppingCartCount } from './../../dataServices/getShoppingCartCount';
import { lang, getCurrentSystem, SYSTEM_TYPE } from '@umu/ukit-lang';

const COMMON_HEADER_ID = 'common-header';
const SIMPLE_HEADER_ID = 'simple-header-id';

export enum CourseType {
    Normal,
    Tsinghua,
    Mercer,
}

/**
 *
 * 未登录情况，market header
 */
export function initMarketSimpleHeader(course_type: number, text?: string) {
    if (getCurrentSystem() !== SYSTEM_TYPE.CN) {
        return;
    }
    const header = document.getElementById(SIMPLE_HEADER_ID);
    if (!header) {
        return;
    }
    header?.classList.add('marker-simple-header');

    const addTitle = () => {
        const container = header.querySelector('.header-wrapper');
        if (!container) {
            return;
        }

        const title = document.createElement('div');
        const titleText =
            course_type === CourseType.Mercer || course_type === CourseType.Tsinghua ? text : lang('UMU 课程市场');
        const path =
            course_type === CourseType.Tsinghua ? 'thusem' : course_type === CourseType.Mercer ? 'mercer' : 'market';
        title.innerHTML = `<a target="_blank" class="title-text" href="/${path}">${titleText}</a>`;
        title.classList.add('market-simple-header-title');
        container.appendChild(title);
    };

    addTitle();
}

/**
 *
 * 登录情况，market header
 */
export function initMarketCommonHeader(
    isAdmin: boolean,
    course_type: number = CourseType.Normal,
    isEnterprise = false,
    text: string,
) {
    if (getCurrentSystem() !== SYSTEM_TYPE.CN) {
        return;
    }
    const commonHeader = document.getElementById(COMMON_HEADER_ID);
    if (!commonHeader) {
        return;
    }
    commonHeader?.classList.add('marker-common-header');
    if (isAdmin) {
        getShoppingCartCount().then((result) => {
            extendMarketHeader(result.data.num, isAdmin, course_type, isEnterprise, text);
        });
    } else {
        $window.setTimeout(() => {
            extendMarketHeader(0, isAdmin, course_type, isEnterprise, text);
        }, 500);
    }
}

export function extendMarketHeader(
    shoppingCartNum: number,
    isAdmin: boolean,
    course_type: number = CourseType.Normal,
    isEnterprise = false,
    text: string,
) {
    const commonHeader = document.getElementById(COMMON_HEADER_ID);
    if (!commonHeader) {
        return;
    }
    const container = commonHeader.querySelector('.page-header-container');
    if (!container) {
        // 兼容IE10，暂不用MutationObserver
        setTimeout(() => {
            extendMarketHeader(shoppingCartNum, isAdmin, course_type, isEnterprise, text);
        }, 200);
        return;
    }

    const addTitle = () => {
        const title = document.createElement('div');
        const titleText =
            course_type === CourseType.Tsinghua || course_type === CourseType.Mercer ? text : lang('UMU 课程市场');
        const path =
            course_type === CourseType.Tsinghua ? 'thusem' : course_type === CourseType.Mercer ? 'mercer' : 'market';
        title.innerHTML = `<a target="_blank" class="title-text" href="/${path}">${titleText}</a>`;
        title.classList.add('market-common-header-title');
        container.appendChild(title);
    };

    const addShoppingCart = () => {
        const shoppingCartTemplate = `<div class="market-common-header-nav-shopping-cart ${
            shoppingCartNum === 0 ? 'zero' : 'no-zero'
        }">
        <a class="btn trackEvent" href="/market/shopping-cart" target="_blank">
            <span class="msg-cnt market-common-header-nav-title">
                <i class="icon"></i>
                <span class="num-tips">${shoppingCartNum}</span>
            </span>
            
        </a>
    </div>`;
        const navOrdersTemplate = `
        <div class="market-common-header-nav-orders ${course_type === CourseType.Tsinghua ? 'tsinghua-orders' : ''}">
            <a class="btn trackEvent" href="/market/manage-orders${
                course_type === CourseType.Tsinghua ? '/tsinghua' : ''
            }" target="_blank">
                <span class="market-common-header-nav-title"></span>
                <i class="icon icon-msg"></i>
            </a>
        </div>
    `;
        // 清华经管课程 c端用户展示订单按钮  非清华经管课程 b端管理员展示购物车和订单
        const template =
            course_type === CourseType.Tsinghua
                ? !isEnterprise
                    ? navOrdersTemplate
                    : ''
                : isAdmin
                ? shoppingCartTemplate + navOrdersTemplate
                : '';
        if (!template) {
            return;
        }
        const tempNode = document.createElement('div');
        tempNode.innerHTML = template;
        container.appendChild(tempNode);
    };

    addTitle();
    addShoppingCart();
}
const src =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHAAAAA4CAMAAAASNYx4AAAAXVBMVEUAAAD/vSr/vSr/vSr/vSr/vSr/vSr/vSr/vSr/vSr/vSr/vSr/vSr/vSr/vSr/vSr/vSr/vSr/vSr/vSr/vSr/vSr/vSr/vSr/vSr/vSr/vSr/vSr/vSr/vSr/vSpAIypRAAAAHnRSTlMAoE/iEe/QgAWyYnhAKB7Zh25GC6e8yvY4xJBWMZhefnaEAAACmUlEQVRYw72W65KjIBBGW5EEULxfY9Lv/5g7bMDWVNTZqrXPj9EinRyg8XPgnGY0r0nKDBiwc6kFvongUpKsivoBieuE6mnKzi/ramEep21BikuEdDAek0TiQqGK73qzrEKKS4UdfmCNuVSInzSmZBWKei5YhW2ZS+z4hO0zh1tsuYRydEMKDJewDhEgeIQlBEYWYa9oOGUQynwTCNcL522Syx1hQjWJWt3TuMqbnRr3Z3cJ81dhUlCnDUrr39SRRBx07Wymd4FcJp810NzwtRIKX0G034Qx4gCeHjHdNjxS+S00qKaaNzUiroQZLTxcxXchgueGeP84YFrQfbbU0FdJ+IBALGKa0m+E49+P57j0XRdpbSZ3bfaEtKGNdaUi9PnxK6F2iUFx0TkP3BExPRAaN/KMBndPu66KXwgTlxj04eA7MiH2B8KfqpwOiQzH+nkqfG98Ts9Y4W8rRDwQpspIJFIKnFOhK1EkFCthsi8ktktU/alwXo1IxJZO3LmQqMBjh2Phl5E32b8JCwhUPEKMKcV5hN0mxUlYfXTsWLjpqjkUooWAIeH2TA6I+lRIc0+PhQ9Y0EHoc2z0WesC40zYIU5+pESUB0KpKM0lCZWbMgVffiZ0LaiX1rQkPDo2MHth0ETJj9mlpYYzoZusdD9lXUxmR0K9fTVG6+XKTrvLYE+E4bEqdL/8JO6y/l9CLEIYKQNnOBdChIG+ORZWQNQkBDv5cMhCwAvwaPqWRZT+SfIzfDVwLLzBirsBYiy1fsQqZJHOwJO3DwXLcB32x0S6TemNsouFCzgSlkAwCCnB2YT4hAtA7j0txR60p0xYgRZYqTAFVhKcgBeNCbASowFWlNTASzQ0wEqNMfAiX8DLSwIvtv/PAf4HKsjKiMeiR2QAAAAASUVORK5CYII=';

export function replaceLogo(uerInfo: IUserInfo) {
    if (getCurrentSystem() !== SYSTEM_TYPE.CN) {
        return;
    }
    if (!uerInfo || !uerInfo.enterprise_id || !uerInfo.enterprise_info) {
        return;
    }

    uerInfo.enterprise_info.logo = src;
}
